module.exports = __webpack_public_path__ + "static/media/notif-m.faf998f7.svg";